import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getUserIn2nAPI } from './api';

export const GET_USER_IN_2N = 'getUserIn2N';

export function useGetUserIn2n(userEmail) {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery(
    [GET_USER_IN_2N, tenantId, userEmail],
    () => getUserIn2nAPI(userEmail),
  );

  return {
    user: data,
    isSuspended: data?.IsSuspended,
    isLoading,
    isFetching,
    isError,
  };
}

